import {lazy} from 'react';

export const ProfileUserAsync = lazy(() =>
    import('./ProfileUser')
);
